<template>
<div>
	<div class="contact-content">
		<a class="link" href="mailto:arthurz@utexas.edu">Email</a>    /
		<a 		class="link" @click="openResume()">Resume</a>  /
		<span 	class="link" @click="redirectToLink('https://www.linkedin.com/in/arthur-k-zhang/')">Linkedin</span>    /
		<span 	class="link" @click="redirectToLink('https://github.com/artzha')">Github</span>
	</div>
</div>
</template>
<script>
import router from '../router'
import NavBar from './NavBar'

export default {
	name: 'Contact',
	components: {
		'nav-bar': NavBar
	},
	data() {
		return {
			navMsg: 'Always looking for an job to build awesome things.'
		}
	},
	methods: {
		redirectToLink: function(url) {
			window.open(url)
		},
		openResume: function() {
			window.open('/../../static/images/Arthur_Zhang_Resume.pdf')
		}
	}
};
</script>
<style scoped>
h1, h2, h4, h5 {
	font-weight: normal;
}
ul {
	list-style-type: none;
	padding: 0;
}
li {
	display: inline-block;
	margin: 0 10px;
}
a {
	color: #42b983;
}
body, html {
	margin: 0px;
	padding: 0;
}
.link {
	color: #3399ff;
	text-decoration: none;
}
.link:hover {
	cursor: pointer;
	text-decoration: underline;
}

.contact-content {
	display: inline-block;
	width: 100%;
	text-align: center;
	margin: auto;
	margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Contact.vue